import React from "react";

import { FormRequired } from "./FormRequired";

interface FormLabelProps {
  label: string;
  hideLabel?: boolean;
  labelIcon?: string | JSX.Element;
  required?: boolean;
}
export const FormLabel: React.FC<FormLabelProps> = ({
  label,
  hideLabel,
  labelIcon,
  required,
}) => {
  if (hideLabel) {
    return <span className="visually-hidden">{label}</span>;
  }

  return (
    <span className="form-label">
      {labelIcon && typeof labelIcon === "string" && (
        <span
          className="form-label__icon"
          dangerouslySetInnerHTML={{ __html: labelIcon }}
        />
      )}
      {labelIcon && typeof labelIcon !== "string" && (
        <span className="form-label__icon">{labelIcon}</span>
      )}
      {label}
      {required && <FormRequired />}
    </span>
  );
};
